import React, { useEffect, useState, useCallback } from "react";
import { FaArrowRight } from "react-icons/fa";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import Header from "../components/header/Header";
import bg_dot from "../assets/images/bg_dot.png";
import bg from "../assets/images/bg.jpeg";
import hang1 from "../assets/images/hang1.png";
import hang2 from "../assets/images/hang2.png";
import hang3 from "../assets/images/hang3.png";
import hangkhac from "../assets/images/hangkhac.png";
import giaithuong from "../assets/images/giaithuong.png";
import giaithuongcbnv from "../assets/images/giaithuongcbnv.png";
import hunghaumungtruyenthong from "../assets/images/banner_right_image.png";
import niemtinHUNGHAU from "../assets/images/vanhientrongtim.png";
import leftBannerText from "../assets/images/banner_left_text.png";
import banner_bottom1 from "../assets/images/banner_bottom1.png";
import banner_bottom2 from "../assets/images/banner_bottom2.png";
import banner_bottom3 from "../assets/images/banner_bottom3.png";
import banner_bottom4 from "../assets/images/banner_bottom4.png";
import banner_bottom5 from "../assets/images/banner_bottom5.png";
import banner_bottom6 from "../assets/images/banner_bottom6.png";
import buoc1 from "../assets/images/Buoc1.png";
import buoc2 from "../assets/images/Buoc2.png";
import buoc3 from "../assets/images/Buoc3.png";
import buoc4 from "../assets/images/Buoc4.png";
import huongdanthamgia from "../assets/images/huongdanthamgia.png";
import luuyquantrong from "../assets/images/luuyquantrong.png";
import tonggiaithuong from "../assets/images/tonggiaithuong.png";
import titlexephangdoi from "../assets/images/titlexephangdoi.png";
import titlexephangcanhan from "../assets/images/titlexephangcanhan.png";
import khungxanh from "../assets/images/khungxanh.png";
import buttonCaNhan from "../assets/images/buttonCaNhan.png";
import buttonTapThe from "../assets/images/buttonTapThe.png";
import samset from "../assets/images/samset.png";
import huyhieutapthe from "../assets/images/huyhieutapthe.png";
import huyhieucanhan from "../assets/images/huyhieucanhan.png";
import hang1canhan from "../assets/images/hang1canhan.png";
import hang2canhan from "../assets/images/hang2canhan.png";
import hang3canhan from "../assets/images/hang3canhan.png";
import harmony from "../assets/images/harmony.png";
import heart from "../assets/images/heart.png";
import myu from "../assets/images/myu.png";
import sync from "../assets/images/sync.png";
import connect from "../assets/images/connect.png";
import global from "../assets/images/global.png";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import CustomCarousel from "../components/Slider/slider";
import { mission, result } from "../controller";
import { color } from "highcharts";
import { userEvent } from "../controller";
import Noti from "../components/Noti";

const initialTasks = [
  {
    id: "1",
    title: "Nhiệm vụ 01: +20 điểm",
    description: (
      <>
        <b>
          Quay một đoạn clip ngắn (vlog, phỏng vấn, review…) chia sẻ trải
          nghiệm, cảm nghĩ, hoặc những điều bạn yêu thích về Đại học Văn Hiến,
          có thể xoay quanh: cơ sở vật chất, môi trường học tập, giảng viên,
          hoạt động sinh viên và các sự kiện mà bạn tham gia...
        </b>
        <br />
        Yêu cầu:
        <ul className="mt-2 mb-2 ml-5 text-base list-disc">
          <li>Thời lượng clip: 1–3 phút</li>
          <li>
            Chất lượng clip: Hình ảnh rõ nét, ánh sáng đầy đủ, âm thanh rõ ràng.
          </li>
          <li>
            Nội dung: Là những trải nghiệm cá nhân, chân thực tại giảng đường
            hoặc trong các hoạt động gắn với Văn Hiến.
          </li>
          <li>
            Kênh đăng tải: Clip cần được đăng tải công khai tại 1 trong các nền
            tảng mạng xã hội cá nhân: Facebook, Tiktok, Instagram, Youtube.
          </li>
          <li>
            Bài đăng đi kèm hashtag: <b>#VHU #DaihocVanHien #VanHientrongtim</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "2",
    title: "Nhiệm vụ 02: +10 điểm",
    description: (
      <>
        <b>
          Chụp và đăng tải một bức ảnh check-in tại Đại học Văn Hiến chia sẻ
          trải nghiệm, cảm nghĩ, hoặc những điều bạn yêu thích về Đại học Văn
          Hiến, có thể xoay quanh: cơ sở vật chất, môi trường học tập, giảng
          viên, hoạt động sinh viên và các sự kiện mà bạn tham gia...
        </b>
        <br />
        Yêu cầu:
        <ul className="mt-2 mb-2 ml-5 text-base list-disc">
          <li>Hình ảnh rõ ràng, sắc nét và đạt chất lượng tốt.</li>
          <li>
            Caption thể hiện được những chia sẻ, cảm nghĩ, tình cảm với VHU.
          </li>
          <li>
            Hình thức: có thể là ảnh tự chụp, tự thiết kế, vẽ tay, hoặc sáng tạo
            bất kỳ có liên quan đến Đại học Văn Hiến
          </li>
          <li>
            Kênh đăng tải: Hình ảnh và nội dung cần được đăng tải công khai tại
            1 trong các nền tảng mạng xã hội cá nhân: Facebook, Tiktok,
            Instagram, YouTube.
          </li>
          <li>
            Bài đăng đi kèm hashtag: <b>#VHU #DaihocVanHien #VanHientrongtim</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "3",
    title: "Nhiệm vụ 03: +5 điểm",
    description: (
      <>
        <b>
          Chia sẻ những khoảnh khắc đáng nhớ của cá nhân hoặc cùng bạn bè, đồng
          nghiệp, giảng viên tại lớp học, câu lạc bộ hoặc trong các hoạt động,
          sự kiện, không gian của Đại học Văn Hiến.
        </b>
        <br />
        Yêu cầu:
        <ul className="mt-2 mb-2 ml-5 text-base list-disc">
          <li>
            Chất lượng hình ảnh: Rõ nét, phù hợp với tinh thần và tiêu chí của
            chương trình.
          </li>
          <li>
            Kênh đăng tải: Hình ảnh và nội dung cần được đăng tải công khai tại
            1 trong các nền tảng mạng xã hội cá nhân: Facebook, Tiktok,
            Instagram, Youtube.
          </li>
          <li>
            Bài đăng đi kèm hashtag: <b>#VHU #DaihocVanHien #VanHientrongtim</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "4",
    title: "Nhiệm vụ 04: +2 điểm",
    description: (
      <>
        <b>
          Chia sẻ ở chế độ công khai các bài đăng từ các kênh mạng xã hội của
          Đại học Văn Hiến (Fanpage, Zalo, Tiktok, Website…) lên các tài khoản
          mạng xã hội cá nhân của bạn.
        </b>
        <br />
        Yêu cầu:
        <ul className="mt-2 mb-2 ml-5 text-base list-disc">
          <li>Bài đăng ở chế độ công khai</li>
          <li>
            Bài đăng đi kèm hashtag: <b>#VHU #DaihocVanHien #VanHientrongtim</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
];

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels, // Đăng ký plugin để hiển thị nhãn dữ liệu trên biểu đồ
);

export const options = (title) => {
  return {
    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      datalabels: {
        align: "end", // align at end of bar
        anchor: "", // anchor to end of bar
        offset: 4, // small space from edge
        color: "white",
        font: {
          size: 12,
          weight: "bold",
        },
        formatter: (value) => {
          return value > 0 ? value : null; // only show if > 0
        },
        clamp: true, // prevent from going outside chart
      },
      legend: {
        display: false,
      },
      tooltip: {
        // backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "white",
        bodyColor: "white",
        // borderColor: "transparent",
        // borderWidth: 1,
      },
      title: {
        display: true,
        text: title,
        color: "white",
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ffffff", // màu chữ trên trục X
        },
      },
      y: {
        ticks: {
          color: "#ffffff", // màu chữ trên trục Y
        },
      },
    },
  };
};

export default function Events() {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState(initialTasks);
  const [openTask, setOpenTask] = useState(null);
  // const [groupData, setGroupData] = useState();
  const [teamsData, setTeamsData] = useState([]);
  const [teamsDataCLB, setTeamsDataCLB] = useState([]);
  const [topUserData, setTopUserData] = useState([]);
  const [topUserDataGiangVien, setTopUserDataGiangVien] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("hhh");
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [selectedTeamName, setSelectedTeamName] = useState("");
  const [submitStatus, setSubmitStatus] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [info, setInfo] = useState({});
  const [submitLink, setSubmitLink] = useState({
    // 1 là tập thể, 2 là cá nhân
    1: "",
    2: "",
  });

  useEffect(() => {
    // scroll to top when component mounts
    window.scrollTo(0, 0);

    // Chặn mở F12 và các phím tắt DevTools
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        e.keyCode === 123 ||
        (e.ctrlKey &&
          e.shiftKey &&
          (e.key === "I" ||
            e.key === "i" ||
            e.key === "J" ||
            e.key === "j" ||
            e.key === "C" ||
            e.key === "c" ||
            e.key === "U" ||
            e.key === "u")) ||
        (e.metaKey &&
          e.altKey &&
          (e.key === "I" ||
            e.key === "i" ||
            e.key === "J" ||
            e.key === "j" ||
            e.key === "C" ||
            e.key === "c" ||
            e.key === "U" ||
            e.key === "u"))
      ) {
        e.preventDefault();
      }
    };

    // Chặn menu chuột phải (ngăn Inspect / Kiểm tra phần tử qua chuột)
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleContextMenu);

    // Hàm kiểm tra thời gian đóng/mở
    const checkCloseTime = () => {
      const now = new Date();
      // Đóng từ 17:00:00 ngày 25/08/2026
      const closeTime = new Date(2026, 7, 25, 17, 0, 0, 0);
      if (now >= closeTime) {
        setIsClosed(true);
      } else {
        setIsClosed(false);
      }
    };
    checkCloseTime(); // Kiểm tra ngay khi vào trang
    // Thiết lập interval kiểm tra mỗi phút
    const interval = setInterval(checkCloseTime, 20 * 1000);
    return () => {
      clearInterval(interval);
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  // Create combined options array
  const teamOptions = ["Harmony", "Heart", "Global", "myU", "Connect", "Sync"];

  // Map names to image paths
  const getImagePath = (name) => {
    // Create mapping for specific names first

    // KHOA mapping
    if (name === "Harmony") {
      return harmony;
    } else if (name === "Heart") {
      return heart;
    } else if (name === "Global") {
      return global;
    } else if (name === "myU") {
      return myu;
    } else if (name === "Connect") {
      return connect;
    } else if (name === "Sync") {
      return sync;
    }
  };

  // Combine all options
  const allOptions = [...teamOptions];
  // Create slides with 6 items each
  const createSlides = () => {
    const slides = [];
    for (let i = 0; i < allOptions.length; i += 6) {
      slides.push(allOptions.slice(i, i + 6));
    }
    return slides;
  };

  const khoaSlides = createSlides();

  // Functions cho slider
  // const nextSlide = () => {
  //   setCurrentSlide((prev) => (prev + 1) % khoaSlides.length);
  // };

  // const prevSlide = () => {
  //   setCurrentSlide(
  //     (prev) => (prev - 1 + khoaSlides.length) % khoaSlides.length
  //   );
  // };
  // const goToSlide = (index) => {
  //   setCurrentSlide(index);
  // };

  // Auto-play functionality for slider
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % khoaSlides.length);
    }, 400000); // Change slide every 4 seconds

    return () => clearInterval(interval);
  }, [khoaSlides.length]);
  const TaskPopup = ({ task, onClose }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-[#0091EB]/90 rounded-2xl shadow-xl max-w-2xl max-md:max-w-full max-md:mx-4 w-full py-4 relative animate-fadeIn">
        <div className="transform -translate-y-8 scale-[1.02] border w-full bg-gradient-to-b from-[#07B4FE] to-[#0044D7] rounded-3xl relative z-10 flex items-center justify-center leading-tight h-fit p-4">
          <button
            className="absolute text-2xl text-white top-2 right-4 hover:text-red-500"
            onClick={onClose}
          >
            &times;
          </button>
          <h2 className="bg-gradient-to-b leading-normal text-5xl max-lg:text-2xl text-center from-[#FFD942] via-[#FFA22F] to-[#FF7E22] bg-clip-text text-transparent font-bold">
            {task.title}
          </h2>
        </div>
        <div className="px-6 text-xl text-white">{task.description}</div>
      </div>
    </div>
  );

  // Confirmation popup component
  const ConfirmationPopup = ({ teamName, onConfirm, onCancel }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="w-full max-w-md p-6 mx-4 bg-white shadow-xl rounded-2xl">
        <h2 className="mb-4 text-2xl font-bold text-center text-gray-800">
          Xác nhận chọn đội
        </h2>
        <p className="mb-6 text-center text-gray-600">
          Bạn có chắc chắn muốn chọn <strong>{teamName}</strong> làm đội của
          mình không?
        </p>
        <div className="flex gap-4">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 text-gray-700 transition-colors border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            Hủy
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 bg-gradient-to-r from-[#0253e1] to-[#25c8ff] text-white rounded-lg hover:opacity-90 transition-opacity"
          >
            Xác nhận
          </button>
        </div>
      </div>
    </div>
  );

  // Handle team selection click
  const handleTeamSelection = async (teamName) => {
    try {
      // Check if user already has a team
      const phone =
        sessionStorage.getItem("phoneNumber") ||
        localStorage.getItem("phoneNumber");
      const userEventData = await userEvent.getUserEvent({
        phoneNumber: phone,
        event: "minigameVhu30",
      });

      if (userEventData?.userEvent?.team) {
        // User already has a team, navigate directly to TeamPage
        sessionStorage.setItem("team", userEventData.userEvent.team);
        alert("Bạn đã có đội thi: " + userEventData.userEvent.team);
        navigate("/user/teams/" + userEventData.userEvent.team);
      } else {
        // User doesn't have a team, show confirmation popup
        setSelectedTeamName(teamName);
        setShowConfirmPopup(true);
      }
    } catch (error) {
      console.error("Error checking user team:", error);
      // If error occurs, show confirmation popup as fallback
      setSelectedTeamName(teamName);
      setShowConfirmPopup(true);
    }
  };

  // Handle team selection confirmation
  const handleConfirmTeamSelection = async () => {
    try {
      // Call updateTeam API
      const phone =
        sessionStorage.getItem("phoneNumber") ||
        localStorage.getItem("phoneNumber");
      const result = await userEvent.updateTeam({
        phoneNumber: phone,
        event: "minigameVhu30",
        team: selectedTeamName,
      });

      if (result) {
        // Success - navigate to TeamPage
        setShowConfirmPopup(false);
        sessionStorage.setItem("team", selectedTeamName);
        alert("Đăng ký đội thi thành công: " + selectedTeamName);
        navigate("/user/teams/" + selectedTeamName);
      } else {
        alert("Có lỗi xảy ra khi chọn đội. Vui lòng thử lại!");
      }
    } catch (error) {
      console.error("Error updating team:", error);
      alert("Có lỗi xảy ra khi chọn đội. Vui lòng thử lại!");
    }
  };

  // Handle team selection cancellation
  const handleCancelTeamSelection = () => {
    setShowConfirmPopup(false);
    setSelectedTeamName("");
  };
  const fetchGroupResult = useCallback(async () => {
    try {
      const response = await result.getTeamsResult();
      const data = Object.entries(response)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 10) // Chỉ lấy top 10
        .map(([key, value]) => ({ key, value }));
      setTeamsData(data);
    } catch (error) {
      console.log(error);
    }
  }, []);
  const getTop10ResultSinhVien = useCallback(async () => {
    try {
      const response = await result.getTop10Result({
        donvi: ["sinhvien", "tansinhvien"],
      });
      setTopUserData(response);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getTop10ResultGiangVien = async () => {
    try {
      const response = await result.getTop10Result({
        donvi: ["giangvien", "cuusinhvien", "hocviencaohoc"],
      });
      setTopUserDataGiangVien(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // Fetch dữ liệu lần đầu khi component mount
    getTop10ResultSinhVien();
    getTop10ResultGiangVien();
    // fetchGroupResult();
    fetchUserEvent();
    // Thiết lập interval để fetch dữ liệu mỗi 60 giây
    const interval = setInterval(() => {
      getTop10ResultSinhVien();
      getTop10ResultGiangVien();
      // fetchGroupResult();
    }, 60000);

    return () => clearInterval(interval);
  }, []);
  const scrollToSection = (id) => {
    // setShowMenu(false);
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }, 200); // Wait for menu to close
  };

  const handleSubmit = async (id) => {
    if (isClosed) {
      alert("Đã hết thời gian nộp bài. Hệ thống đã đóng nhận bài thi!");
      return;
    }
    try {
      // setIsLoading(true);
      const result = await mission.createSubmission({
        userEventId: JSON.parse(sessionStorage.getItem("userInfo")).userEvent
          .id,
        mission: Number(id),
        link: submitLink[id],
      });
      if (result.message === "Submission created successfully") {
        setSubmitStatus(true);
        // setTasks((tasks) =>
        //   tasks.map((task) => (task.id === id ? { ...task, input: "" } : task))
        // );
        // Refresh submissions after successful submit and reset to first page
        // setSubmissionPagination((prev) => ({ ...prev, page: 1 }));
        // fetchSubmissions(1, submissionPagination.limit);
      } else {
        throw new Error(result.message || "Failed to submit task");
      }
    } catch (error) {
      console.error("Error submitting task:", error);
      alert(error.message || "Failed to submit task");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUserEvent = useCallback(async () => {
    const phone =
      sessionStorage.getItem("phoneNumber") ||
      localStorage.getItem("phoneNumber");
    if (!phone) return;

    try {
      setIsLoading(true);
      const response = await userEvent.getUserEvent({
        phoneNumber: phone,
        event: "minigameVhu30",
      });

      if (response) {
        // console.log("User events fetched successfully:", response);
        sessionStorage.setItem(
          "userInfo",
          JSON.stringify({ userEvent: response.userEvent }),
        );
        setInfo({
          name: response?.userEvent?.name || "User",
          id: response?.userEvent?.id || "",
        });
      }
    } catch (error) {
      console.error("Error fetching user events:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return (
    <div
      // style={{ backgroundImage: `url(${bg})`, backgroundSize: "cover" }}
      className=" min-h-screen pb-10 relative bg-[#0043D3] bg-no-repeat bg-cover bg-center"
    >
      <Header />
      {submitStatus && (
        <Noti
          message={<span>Đã gửi kết quả nhiệm vụ thành công!</span>}
          onClose={() => setSubmitStatus(false)}
        ></Noti>
      )}
      <div className="w-11/12 p-4 mx-auto">
        {/* Popup Task */}
        {openTask && (
          <TaskPopup task={openTask} onClose={() => setOpenTask(null)} />
        )}
        {showConfirmPopup && (
          <ConfirmationPopup
            teamName={selectedTeamName}
            onClose={() => setShowConfirmPopup(false)}
            onConfirm={handleConfirmTeamSelection}
            onCancel={handleCancelTeamSelection}
          />
        )}
        <div className="flex items-stretch justify-between gap-10 mt-10 mb-20 banner max-md:flex-col max-md:items-start max-md:gap-4">
          <div className="flex flex-col items-start justify-center banner_left basis-5/12">
            <img
              className="object-cover w-full mt-4"
              src={leftBannerText}
            ></img>
            {/* <img className="mt-4" src={niemtinHUNGHAU}></img> */}
            <span className="block mt-4 text-lg font-bold text-white max-md:text-justify">
              Chào mừng 30 năm thành lập Trường Đại học Văn Hiến!
              <br />
              <br />
              Dù bạn là Sinh viên, Tân sinh viên, Cựu sinh viên, Giảng viên hay
              CBNV, chắc hẳn đã và đang có những khoảnh khắc đáng nhớ cùng Văn
              Hiến.
              <br />
              <br />
              Hãy chọn những bức ảnh thật ý nghĩa, cập nhật khung “Chào mừng
              VHU30, chào đón K29” và chia sẻ câu chuyện của bạn với Minigame
              “VHU30, tôi bao nhiêu?”.
              <br />
              <br />
              Mỗi bức ảnh là một dấu mốc, mỗi câu chuyện là một mảnh ghép góp
              phần tạo nên hành trình rực rỡ của VHU30, đồng thời chào đón K29 –
              thế hệ mới sẽ tiếp nối những câu chuyện và giá trị của Văn Hiến ❤️
            </span>
            <button
              onClick={() => scrollToSection("section-submit")}
              className="mt-4 flex items-center justify-center gap-2 text-[20px] px-8 py-3 bg-gradient-to-r from-[#f23f0f] to-[#fcc606] text-white rounded-full hover:opacity-90 transition-opacity w-full animate-pulse font-bold shadow-lg"
            >
              <span>THAM GIA NGAY </span>
              <FaArrowRight />
            </button>
          </div>
          <div className="items-end gap-4 banner_right basis-7/12 ">
            <img
              className="max-h-[500px] col-span-3  w-full object-cover"
              src={hunghaumungtruyenthong}
              alt="img-1"
            />
          </div>
        </div>

        <div className="grid w-full grid-cols-3 gap-4 mt-10 banner_bottom max-md:grid-cols-1">
          <img className="object-cover w-full" src={banner_bottom1}></img>
          <img className="object-cover w-full" src={banner_bottom2}></img>
          <img className="object-cover w-full" src={banner_bottom3}></img>
          <img className="object-cover w-full" src={banner_bottom4}></img>
          <img className="object-cover w-full" src={banner_bottom5}></img>
          <img className="object-cover w-full" src={banner_bottom6}></img>
          {/* <img className="object-cover w-full" src={gioithieu1}></img>
          <img className="object-cover w-full" src={gioithieu2}></img>
          <img className="object-cover w-full" src={gioithieu3}></img>
          <img className="object-cover w-full" src={gioithieu4}></img>
          <img className="object-cover w-full" src={gioithieu5}></img>
          <img className="object-cover w-full" src={gioithieu6}></img> */}
        </div>

        <div
          id="section-nhiemvu"
          className="grid items-stretch w-full md:w-11/12 grid-cols-1 gap-4 mx-auto font-thin max-md:grid-cols-1"
        >
          <div id="section-thele" className="relative mt-40">
            <div className="w-full">
              <h2 className="text-[#00FFFF] max-md:text-2xl text-5xl font-bold text-center">
                CUỘC THI ẢNH
                <br></br>
                “VHU30, TÔI BAO NHIÊU?”
              </h2>
            </div>
            <div className="mt-10 w-full" id="huongdanthamgia">
              <img
                className="min-w-7/12 object-fit"
                src={huongdanthamgia}
              ></img>
              <div className="gap-4 mt-4 text-lg text-white flex-col">
                <div className="p-4 max-md:flex-col flex items-center max-md:justify-center gap-4 bg-[#0000EA]/30 rounded-2xl font-bold">
                  <img src={buoc1} className="max-h-40 max-md:max-h-20"></img>
                  <div>
                    <div className="font-bold text-3xl">
                      Tạo khung ảnh “Chào mừng VHU30, chào đón K29”
                    </div>
                    <div className="">
                      Người tham gia truy cập đường link{" "}
                      <a
                        className="text-[#FFC800]  underline"
                        href="https://vhu30.vhu.edu.vn/avatar"
                      >
                        https://vhu30.vhu.edu.vn/avatar
                      </a>{" "}
                      để tạo khung ảnh
                      <span className="text-[#FFC800]">
                        {" "}
                        “Chào mừng VHU30, chào đón K29”.
                      </span>
                    </div>
                    {/* <Link
                      to="/user/avatar"
                      className="mt-3 inline-flex items-center justify-center gap-2 px-6 py-2.5 bg-gradient-to-r from-[#FF9900] to-[#FF5500] text-white font-bold rounded-xl shadow-lg hover:opacity-90 transition-opacity animate-pulse text-base"
                    >
                      <span>Tạo khung ảnh ngay</span>
                      <FaArrowRight />
                    </Link> */}
                    <a
                      className="mt-3 inline-flex items-center justify-center gap-2 px-6 py-2.5 bg-gradient-to-r from-[#FF9900] to-[#FF5500] text-white font-bold rounded-xl shadow-lg hover:opacity-90 transition-opacity animate-pulse text-base"
                      href="https://vhu30.vhu.edu.vn/avatar"
                      rel="noopener noreferrer"
                    >
                      Tạo khung ảnh ngay
                    </a>
                  </div>
                </div>
                <div className="p-4 max-md:flex-col flex items-center max-md:justify-center gap-4 bg-[#0000EA]/30 rounded-2xl mt-4 font-bold">
                  <img src={buoc2} className="max-h-40 max-md:max-h-20"></img>
                  <div className="w-full">
                    <div className="rounded-2xl mt-2 p-2">
                      <div className="font-bold text-3xl">
                        Thay ảnh đại diện hoặc đăng tải hình ảnh trên Facebook
                      </div>
                      <div className="">
                        Sau khi tạo khung ảnh, sử dụng hình ảnh đã được cập nhật
                        khung để thay ảnh đại diện hoặc đăng tải công khai lên
                        Facebook.
                        <ul className="mt-2 ml-5 list-disc">
                          <li>
                            Thay ảnh đại diện công khai trên Facebook
                            <span className="text-[#FFC800]"> +10 điểm</span>
                          </li>
                          <li>
                            Đăng tải hình ảnh ở chế độ công khai trên Facebook:
                            <span className="text-[#FFC800]"> +5 điểm</span>
                            <br></br>
                            (Không giới hạn số lượt tham gia trong ngày)
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="bg-[#0014F2]/60 rounded-2xl mt-2 p-2 border font-bold">
                      <b className="font-bold text-lg">Lưu ý về caption:</b>
                      <br></br>
                      Khi đăng tải, caption bài viết cần bắt đầu bằng câu:
                      <br></br>
                      <span className="text-[#FFC800]">
                        Chào mừng 30 năm thành lập Trường Đại học Văn Hiến!
                        <br></br>
                        VHU30, tôi … tuổi.
                      </span>
                      <br></br>
                      Trong đó, “… tuổi” là độ tuổi của bạn tại thời điểm bức
                      ảnh được chụp.
                      <br></br>
                      <span className="font-light">Ví dụ:</span>
                      <ul className="mt-2 ml-5 list-disc font-light">
                        <li>
                          “VHU30, tôi 18 tuổi” – với hình ảnh được chụp khi bạn
                          18 tuổi.
                        </li>
                        <li>
                          “VHU30, tôi 22 tuổi” – với hình ảnh được chụp khi bạn
                          22 tuổi
                        </li>
                      </ul>
                      <span className=" font-light">
                        (Lưu ý bạn được sử dụng hình ảnh ở bất kỳ độ tuổi nào,
                        nhưng khuyến khích sử dụng hình ảnh được chụp tại VHU)
                      </span>
                      <br></br>
                      <b>
                        Sau câu mở đầu, người tham gia có thể chia sẻ thêm những
                        kỷ niệm, câu chuyện, cảm xúc hoặc dấu ấn đáng nhớ gắn
                        liền với bức ảnh của mình.{" "}
                      </b>
                      <br></br>
                      <b className="font-bold text-lg">
                        Đồng thời, bài đăng kèm theo đầy đủ Hashtag:
                      </b>
                      <br></br>
                      <span className="text-[#FFC800] font-bold w-full break-words">
                        {/* Nếu quá dài thì xuống dòng */}
                        #DaihocVanHien #VanHienUniversity #VHU #ChaomungVHU30
                        #ChaodonK29 #VHU30Toibaonhieu
                      </span>
                    </div>
                  </div>
                </div>
                <div className="p-4 max-md:flex-col flex items-center max-md:justify-center gap-4 bg-[#0000EA]/30 rounded-2xl mt-4 font-bold">
                  <img src={buoc3} className="max-h-40 max-md:max-h-20"></img>
                  <div>
                    <div className="font-bold text-3xl">
                      Truy cập Landing Page và cập nhật kết quả{" "}
                    </div>
                    <div className="">
                      Người tham gia truy cập Landing Page:{" "}
                      <a
                        className="text-[#FFC800]  underline"
                        href="https://vhu30.vhu.edu.vn/"
                      >
                        https://vhu30.vhu.edu.vn/
                      </a>
                      <br></br>
                      Đăng nhập và nhập đường link ảnh đại diện hoặc bài đăng
                      trên Facebook để hệ thống ghi nhận kết quả, cộng điểm và
                      cập nhật thứ hạng trên bảng xếp hạng.
                    </div>
                  </div>
                </div>
                <div className="p-4 max-md:flex-col flex items-center max-md:justify-center gap-4 bg-[#0000EA]/30 rounded-2xl mt-4 font-bold">
                  <img src={buoc4} className="max-h-40 max-md:max-h-20"></img>
                  <div>
                    <div className="font-bold text-3xl">
                      Tham gia Minigame mỗi ngày{" "}
                    </div>
                    <div className="">
                      Tham gia Minigame hằng ngày để tích lũy thêm điểm, nâng
                      cao thứ hạng và từng bước chinh phục vị trí dẫn đầu trên
                      bảng xếp hạng.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="luuyquantrong" className="mt-10">
              <img src={luuyquantrong}></img>
              <div className="gap-4 mt-4 text-lg text-white">
                <div className="font-bold">
                  1. Thời gian tham gia:{" "}
                  <span className="text-[#FFC800]">
                    {" "}
                    Từ ngày 14/8/2026 đến 17h00 ngày 25/8/2026
                  </span>
                  <br></br>
                  <b>2. Đối tượng:</b>
                  <span className="text-[#FFC800]">
                    {" "}
                    Sinh viên, Tân sinh viên, Học viên/Cựu học viên cao học, Cựu sinh viên, Giảng viên, CBNV
                    HungHau Holdings
                  </span>
                </div>
                <span className="font-bold">3. Quy định từ Ban tổ chức:</span>
                <ul className="mt-2 ml-5 list-disc">
                  <li>
                    Người tham gia có thể chia sẻ hình ảnh và tham gia Minigame
                    không giới hạn số lần trong thời gian chương trình diễn ra.
                    <span className="text-[#FFC800] font-bold">
                      {" "}
                      Mỗi bài đăng (1 đường link, 1 hình ảnh) chỉ được tính điểm
                      1 lần duy nhất.
                    </span>
                  </li>
                  <li>
                    Hình ảnh cần rõ nét, phù hợp thuần phong mỹ tục, được cập
                    nhật đầy đủ khung ảnh “Chào mừng VHU30, chào đón K29” trước
                    khi thay ảnh đại diện hoặc đăng tải lên Facebook.
                  </li>
                  <li>
                    Được sử dụng hình ảnh ở bất kỳ độ tuổi nào nhưng khuyến
                    khích sử dụng hình ảnh được chụp tại Trường Đại học Văn Hiến
                    hoặc hình ảnh ghi lại những dấu ấn trong thời học sinh –
                    sinh viên.
                  </li>
                  <li>
                    Bài đăng chỉ được ghi nhận điểm khi đáp ứng đầy đủ các điều
                    kiện: có khung ảnh và caption theo quy định, đầy đủ hashtag,
                    được đăng ở chế độ công khai và tài khoản Facebook không ở
                    chế độ riêng tư.
                  </li>
                  <li>
                    Bài đăng đã bị xóa hoặc chuyển sang chế độ riêng tư trong
                    hoặc sau thời gian diễn ra chương trình sẽ không được tính
                    điểm.
                  </li>
                  <li>
                    Ban Tổ chức có quyền không ghi nhận, loại bỏ hoặc trừ điểm
                    đối với các trường hợp không tuân thủ thể lệ, sử dụng hình
                    ảnh hoặc nội dung không phù hợp.
                  </li>
                  <li>
                    Người tham gia đồng ý để Ban Tổ chức sử dụng hình ảnh và nội
                    dung bài đăng cho mục đích truyền thông, quảng bá chương
                    trình.
                  </li>
                  <li>
                    Trong mọi trường hợp, quyết định của Ban Tổ chức là quyết
                    định cuối cùng.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section-submit" className="w-11/12 mx-auto">
        <div className="w-full p-4 mt-20 rounded-2xl">
          {/* <div className="flex flex-col items-center w-full">
            <img
              src={buttonTapThe}
              alt="Button Tập thể"
              className="object-contain w-1/2 mb-4 max-h-36"
            />
            <div className="w-full flex max-md: justify-between bg-[#B9FFFC]/20 rounded-2xl p-4 max-md:flex-col max-md:items-center max-md:gap-4">
              <div className="flex flex-col w-10/12 gap-4 p-4">
                <input
                  onChange={(e) =>
                    setSubmitLink({ ...submitLink, 1: e.target.value })
                  }
                  type="text"
                  placeholder="Nhập link hình ảnh chia sẻ"
                  className="w-full p-2 text-lg text-white bg-transparent rounded-2xl"
                />
              </div>
              <button
                disabled={isClosed}
                className="bg-gradient-to-t disabled:cursor-not-allowed from-[#f1c562] via-[#F19F1C] to-[#f1c562] flex-grow text-white px-8 py-4 rounded-2xl hover:opacity-90 transition-opacity max-md:w-full flex items-center justify-center gap-2 font-bold"
              >
                <span>GỬI KẾT QUẢ</span>
                <FaArrowRight />
              </button>
            </div>
          </div> */}
          <div className="flex flex-col items-center w-full">
            <h2 className="text-3xl font-bold text-[#3DC000] mb-8">
              GỬI LINK ẢNH TẠI ĐÂY
            </h2>
            <div className="w-full flex justify-between bg-[#A7FFA7] rounded-2xl p-4 max-md:flex-col max-md:items-center max-md:gap-4">
              <div className="flex flex-col w-10/12 gap-4 p-4">
                <input
                  onChange={(e) =>
                    setSubmitLink({ ...submitLink, 2: e.target.value })
                  }
                  type="text"
                  placeholder="Nhập Link hình ảnh chia sẻ"
                  className="w-full p-2 text-lg text-black bg-white rounded-2xl"
                />
              </div>
              <button
                disabled={isClosed}
                onClick={() => handleSubmit(2)}
                className="bg-gradient-to-t disabled:cursor-not-allowed from-[#3DC000] to-[#2BFF00] flex-grow text-white px-8 py-4 rounded-2xl hover:opacity-90 transition-opacity max-md:w-full flex items-center justify-center gap-2 font-bold text-lg"
              >
                <span>GỬI KẾT QUẢ</span>
                <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="w-11/12 mx-auto">
        <div id="section-xephang" className="w-full p-4 mt-40 rounded-2xl">
          {/* Dòng đầu tiên: 2 bảng cá nhân */}
          {/* <h2 className="mt-10 text-3xl font-bold text-center text-white">
            BẢNG XẾP HẠNG CÁ NHÂN
          </h2> */}
          <div className="grid grid-cols-1 gap-10 mt-10 max-md:grid-cols-1">
            {/* Bảng xếp hạng cá nhân sinh viên */}
            <div className="w-full h-full flex flex-col gap-2 bg-[#B9FFFC]/20 rounded-2xl p-8 max-md:p-2">
              <div className="flex items-center justify-center gap-4">
                {/* h1 text gradient color from #FAD185 to #E0AA65 */}
                <h1 className="max-md:text-2xl text-3xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-b from-[#FAD185] via-[#E0AA65] to-[#FAD185]">
                  BẢNG XẾP HẠNG
                  <br></br>
                  SINH VIÊN VÀ TÂN SINH VIÊN
                </h1>
              </div>
              {topUserData.length > 0 ? (
                <div className="flex flex-col h-full rounded-2xl">
                  <ul className="flex flex-col justify-start grow ">
                    {" "}
                    {topUserData.map((user, index) => (
                      <li
                        key={index}
                        className="bg-[#0074f7] px-3 mb-2 h-20 flex justify-center items-center gap-6 rounded-lg shadow-md text-white"
                      >
                        <div className="relative w-[10%] max-md:w-[15%] flex items-center justify-center h-full">
                          {index < 3 && (
                            <img
                              alt="avatar"
                              className="object-cover rounded-full max-w-[70px] max-h-[70px]"
                              src={
                                index === 0
                                  ? hang1
                                  : index === 1
                                    ? hang2
                                    : hang3
                              }
                            />
                          )}
                          {index > 2 && (
                            // <span
                            //   className="absolute max-md:text-sm w-fit h-fit top-[50%] left-[50%] transform -translate-x-[60%] translate-y-[-50%] inset-0 flex items-center justify-center text-white font-bold text-lg pointer-events-none"
                            //   style={{
                            //     textShadow: "0 0 6px #000, 0 0 2px #000",
                            //   }}
                            // >
                            //   {index + 1}
                            // </span>
                            <img
                              alt="avatar"
                              className="object-cover rounded-full max-w-[70px] max-h-[70px]"
                              src={hangkhac}
                            />
                          )}
                        </div>
                        <div className="flex flex-col w-[60%]">
                          <span className="text-2xl font-bold max-md:text-sm ">
                            {user?.userEvent?.name}
                          </span>
                          {/* {user?.userEvent?.team && (
                            <span className="text-lg text-gray-600 max-md:text-xs">
                              {user?.userEvent?.team}
                            </span>
                          )} */}
                        </div>
                        <span className="flex items-center gap-2 w-[30%] justify-end">
                          <span className="bg-gradient-to-r from-[#FC8600] to-[#FFA100] text-white font-bold rounded-lg text-xl max-md:px-2 px-8 max-md:py-2 py-4 w-80 text-center">
                            {user.totalScore} điểm{" "}
                          </span>
                          {/* <img
                            className="w-5 h-5"
                            src={samset}
                            alt="samset"
                          ></img> */}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className="flex flex-col items-center p-4 bg-white rounded-2xl">
                  <p className="text-lg">Chưa có dữ liệu</p>
                </div>
              )}
            </div>

            {/* Bảng xếp hạng cá nhân giảng viên */}
            <div className="w-full h-full flex flex-col gap-2 bg-[#FFE5B9]/20 rounded-2xl p-8 max-md:p-2">
              <div className="flex items-center justify-center gap-4">
                <h1 className="max-md:text-2xl text-3xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-b from-[#FAD185] via-[#E0AA65] to-[#FAD185]">
                  BẢNG XẾP HẠNG
                  <br></br>
                  CỰU SINH VIÊN, GIẢNG VIÊN & CBNV
                </h1>
              </div>
              {topUserDataGiangVien.length > 0 ? (
                <div className="flex flex-col h-full rounded-2xl">
                  <ul className="flex flex-col justify-start grow ">
                    {" "}
                    {topUserDataGiangVien.map((user, index) => (
                      <li
                        key={index}
                        className="bg-[#0074f7] px-3 mb-2 h-20 flex justify-center items-center gap-6 rounded-lg shadow-md text-white"
                      >
                        <div className="relative w-[10%] max-md:w-[15%] flex items-center justify-center h-full">
                          {index < 3 && (
                            <img
                              alt="avatar"
                              className="object-cover rounded-full max-w-[70px] max-h-[70px]"
                              src={
                                index === 0
                                  ? hang1
                                  : index === 1
                                    ? hang2
                                    : hang3
                              }
                            />
                          )}
                          {index > 2 && (
                            <img
                              alt="avatar"
                              className="object-cover rounded-full max-w-[70px] max-h-[70px]"
                              src={hangkhac}
                            />
                          )}
                        </div>
                        <div className="flex flex-col w-[60%]">
                          <span className="text-2xl font-bold max-md:text-sm ">
                            {user?.userEvent?.name}
                          </span>
                          {/* {user?.userEvent?.team && (
                            <span className="text-lg text-gray-600 max-md:text-xs">
                              {index + 1}
                            </span>
                          )}
                        </div>
                        <div className="flex flex-col w-[60%]">
                          <span className="text-2xl font-bold max-md:text-sm ">
                            {user?.userEvent?.name}
                          </span>
                          {/* {user?.userEvent?.team && (
                            <span className="text-lg text-gray-600 max-md:text-xs">
                              {user?.userEvent?.team}
                            </span>
                          )} */}
                        </div>
                        <span className="flex items-center gap-2 w-[30%] justify-end">
                          <span className="bg-gradient-to-r from-[#FC8600] to-[#FFA100] text-white font-bold rounded-lg text-xl max-md:px-2 px-8 max-md:py-2 py-4 w-80 text-center">
                            {user.totalScore} điểm{" "}
                          </span>
                          {/* <img
                            className="w-5 h-5"
                            src={samset}
                            alt="samset"
                          ></img> */}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className="flex flex-col items-center p-4 bg-white rounded-2xl">
                  <p className="text-lg">Chưa có dữ liệu</p>
                </div>
              )}
            </div>
          </div>
        </div>{" "}
      </div>

      <div className=" mx-auto">
        <div id="section-giaithuong" className="mt-40">
          <div className="mx-auto w-11/12 text-center mt-4 p-4">
            <span className="max-md:text-2xl text-5xl font-bold text-[#13FFFF] text-center">
              GIẢI THƯỞNG
              <br></br>
              DÀNH CHO SINH VIÊN & TÂN SINH VIÊN
            </span>
          </div>
          <img
            src={giaithuong}
            className="object-cover w-full rounded-3xl"
            alt="Giải thưởng cuộc thi"
          />
          <div className="mx-auto w-11/12 text-center mt-4 p-4">
            <span className="max-md:text-2xl text-5xl font-bold text-[#13FFFF] text-center">
              GIẢI THƯỞNG
              <br></br>
              DÀNH CHO CỰU SINH VIÊN, GIẢNG VIÊN & CBNV
            </span>
          </div>
          <img
            src={giaithuongcbnv}
            className="object-cover w-full rounded-3xl"
            alt="Giải thưởng cho CBNV"
          />
        </div>
      </div>
      {/* <div id="section-khampha" className="w-11/12 mx-auto mt-40">
        <h2 className="text-2xl font-bold text-center text-white">
          KHÁM PHÁ CHUỖI HOẠT ĐỘNG TẠI SỰ KIỆN
        </h2>
        <div className="w-full p-4 mt-10 rounded-2xl">
          <div className="grid w-full grid-cols-3 gap-4 text-white max-md:grid-cols-2">
            <div className="flex flex-col w-full gap-4">
              <img className="w-full" src={khampha1} />
              <h3 className="text-[#FFD942] text-xl">TEAMBUILDING BECOMING</h3>
              <span className="text-lg font-bold ">
                Bùng cháy năng lượng, gắn kết đồng đội và khẳng định tinh thần
                “Sinh viên khỏe - sẵn sàng bứt phá”!
              </span>
            </div>
            <div className="flex flex-col w-full gap-4">
              <img className="w-full" src={khampha2} />
              <h3 className="text-[#FFD942] text-xl">TRANG TRÍ GIAN HÀNG</h3>
              <span className="text-lg font-bold ">
                Không gian sáng tạo mang đậm dấu ấn từng đội – nơi ý tưởng, màu
                sắc và tinh thần thi đấu cùng thăng hoa.
              </span>
            </div>
            <div className="flex flex-col w-full gap-4">
              <img className="w-full" src={khampha3} />
              <h3 className="text-[#FFD942] text-xl">
                CUỘC THI "VHU STARTUP DEVOTE"
              </h3>
              <span className="text-lg font-bold ">
                Thử sức khởi nghiệp bằng nguồn vốn hỗ trợ, biến ý tưởng kinh
                doanh thành dự án thực tế cùng những trải nghiệm sinh viên đáng
                giá.
              </span>
            </div>
            <div className="flex flex-col w-full gap-4">
              <img className="w-full" src={khampha4} />
              <h3 className="text-[#FFD942] text-xl">
                THI VĂN NGHỆ TRONG ĐÊM GALA
              </h3>
              <span className="text-lg font-bold ">
                Tỏa sáng hết mình trong đêm hội sắc màu, nơi tài năng và cảm xúc
                cùng thăng hoa trên sân khấu.
              </span>
            </div>
            <div className="flex flex-col w-full gap-4">
              <img className="w-full" src={khampha5} />
              <h3 className="text-[#FFD942] text-xl">
                BIỂU DIỄN NGHỆ SĨ KHÁCH MỜI 
              </h3>
              <span className="text-lg font-bold ">
                Những tiết mục sôi động, truyền cảm hứng từ các nghệ sĩ khách
                mời nổi tiếng.
              </span>
            </div>
            <div className="flex flex-col w-full gap-4">
              <img className="w-full" src={khampha6} />
              <h3 className="text-[#FFD942] text-xl">
                ĐỒNG DIỄN VĂN HIẾN TRONG TIM 
              </h3>
              <span className="text-lg font-bold ">
                Màn đồng diễn quy mô, thể hiện niềm tự hào và tinh thần gắn kết
                của sinh viên Văn Hiến.
              </span>
            </div>
            <div className="flex flex-col w-full gap-4">
              <img className="w-full" src={khampha7} />
              <h3 className="text-[#FFD942] text-xl">
                GIAO LƯU VĂN NGHỆ ĐẾN TỪ CÁC CÂU LẠC BỘ 
              </h3>
              <span className="text-lg font-bold ">
                Các tiết mục trẻ trung, sáng tạo đến từ các CLB sinh viên, đậm
                sắc màu VHU.
              </span>
            </div>
            <div className="flex flex-col w-full gap-4">
              <img className="w-full" src={khampha8} />
              <h3 className="text-[#FFD942] text-xl">
                GIAO LƯU KẾT NỐI DOANH NGHIỆP 
              </h3>
              <span className="text-lg font-bold ">
                Cơ hội gặp gỡ, kết nối doanh nghiệp, mở rộng định hướng nghề
                nghiệp cho sinh viên.
              </span>
            </div>
            <div className="flex flex-col w-full gap-4">
              <img className="w-full" src={khampha9} />
              <h3 className="text-[#FFD942] text-xl">
                LAN TỎA GIÁ TRỊ NHÂN VĂN
              </h3>
              <span className="text-lg font-bold ">
                Gây quỹ ủng hộ đồng bào vùng lũ từ lợi nhuận bán hàng của các
                đội từ cuộc thi “VHU Startup Devote"; Tài trợ của doanh
                nghiệp...
              </span>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}
